"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var HudledLogo_1 = __importDefault(require("components/modules/components/HudledLogo"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var AuthIntroSection = function (_a) {
    var description = _a.description, welcomeMsg = _a.welcomeMsg;
    var theme = (0, material_1.useTheme)();
    var isSmallScreen = (0, material_1.useMediaQuery)(theme.breakpoints.down('lg'));
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, md: 6, p: 1 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", alignItems: "flex-start", justifyContent: "center", flexDirection: "column", height: "100%", width: { xs: '100%' }, mt: { xs: 4, md: 0 } }, { children: [(0, jsx_runtime_1.jsx)(HudledLogo_1.default, { height: isSmallScreen ? 24 : 32 }), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 4 }, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: welcomeMsg })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: description }))] })) })));
};
exports.default = AuthIntroSection;
